import React from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneList from './PhoneList';
import CallIcon from '@mui/icons-material/Call';

const Business = ({ business }) => {
  const phoneNumbers = business.phone.split(',');
  const whatsappNumbers = business.whatsapp.split(',');
  return (
    <>
    <div className="shopping-car-element" key={`${business.name}`}>
        <div className="content-left">
          <img src={business.photo_url} alt={business.name} title={business.name} />
          <div>
            <h5>
                {business.name}
            </h5>
            <p>
            {business.description}
            </p>
          </div>
          <div>
          <PhoneList phones={phoneNumbers} linkType='phone' business={business}>
            <CallIcon />
          </PhoneList>
          <PhoneList phones={whatsappNumbers} linkType='whatsapp' business={business}>
            <WhatsAppIcon />
          </PhoneList>
          </div>
        </div>
  </div>
  </>
  );
}

export default Business;
